import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import AccountMenu from '../../Modules/AccountMenu'
import Publicatie from '../../Modules/Kennis/Toevoegen/Publicatie';

class MemberPublicatieAdd extends Component {
  render() {
    return (
      <div className="route">
        <AccountMenu />
        <div className="grey-bg">
          <h1 className="pageTitle">
            Een publicatie toevoegen
            </h1>
          {//<p>Op deze webpagina kunt u uw permanente educatie activiteiten invullen.</p>
            //<p>Bij bekende opleidingen en cursussen kunt u selecteren uit het opleidingen- en cursussenbestand van het Constructeursregister. U krijgt dan direct het aantal kenniseenheden te zien. Definitieve toewijzing van de kenniseenheden vindt plaats na beoordeling door de toetsingscommissie.</p>
          }
          <hr />
          <Row>
            <Col mdPush={2} md={8}>
              <Publicatie /><br /><br />
            </Col>
          </Row>
          {/* <Bijeenkomst /> */}
        </div>
      </div>
    );
  }
}

export default MemberPublicatieAdd;



// WEBPACK FOOTER //
// ./src/components/Member/Pages/Toevoegen/Publicatie.js